import javaRequest from '../utils/javaHttp'
// 列表
export function list (query) {
  return javaRequest({
    url:'/coupon/api/couponSetting',
    method: 'GET',
    headers: {
      'Custom-Params': 'javaApi'
    },
    params: query
  })
}
// 详情
export function edit (query) {
  return javaRequest({
    url:'/coupon/api/couponSetting/'+query.id+'?fetch=image',
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'GET'
  })
}
// 新增
export function save (query) {
  return javaRequest({
    url:'/coupon/api/couponSetting',
    method: 'POST',
    headers: {
      'Custom-Params': 'javaApi'
    },
    data: query
  })
}
// 更新
export function update (query) {
  return javaRequest({
    url:'/coupon/api/couponSetting',
    method: 'PUT',
    headers: {
      'Custom-Params': 'javaApi'
    },
    data: query
  })
}
export function enable (data) {
  return javaRequest({
    url:'/coupon/api/couponSetting/enable/' + data.id,
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'PUT'
  })
}
export function disable (query) {
  return javaRequest({
    url:'/coupon/api/couponSetting/disable/'+query.id,
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'PUT',
  })
}
// 删除
export function del (query) {
  return javaRequest({
    url:'/coupon/api/couponSetting',
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'DELETE',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/Discount.js